export default "__VITE_ASSET__kuEZXrah__"